import { AppRoute } from '@ts-routes/enums'

import { useDisciplineStore } from '@stores/discipline'
import { useProgressReportStore } from '@stores/progress-report'

import { useProgressReportsListApi } from '@api/disciplines/progress-reports/list.hook'

import { resolveProgressReportId } from '@helpers/kid-id'
import { PROGRESS_REPORTS_OPEN_QUERY, PROGRESS_REPORTS_OPEN_UNREAD, findNewestUnreadReport } from '@utils/progress-report/open-unread'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const { getProgressReportList } = useProgressReportsListApi()
  const shouldOpenUnread = to.query[PROGRESS_REPORTS_OPEN_QUERY] === PROGRESS_REPORTS_OPEN_UNREAD

  if (!shouldOpenUnread) {
    void getProgressReportList()
    return
  }

  await getProgressReportList()

  const disciplineStore = useDisciplineStore()
  const progressReportStore = useProgressReportStore()

  const unreadReport = findNewestUnreadReport(progressReportStore.getReports ?? [])
  const reportRoute = disciplineStore.isEla ? AppRoute.ProgressReportEla : AppRoute.ProgressReport
  const reportUrl = unreadReport ? resolveProgressReportId(reportRoute, to.params.kid as string | undefined, unreadReport.id) : null

  if (reportUrl) return navigateTo(reportUrl, { replace: true })

  return navigateTo({ path: to.path, query: { ...to.query, [PROGRESS_REPORTS_OPEN_QUERY]: undefined } }, { replace: true })
})
